import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { GLBANOTICELINK } from "Utils/EnvVars";
import { faro } from "@grafana/faro-react";

import "./Footer.scss";

const Footer = () => {
  const linkClick = (link) => faro.api.pushEvent(`User clicked on ${link} in footer`);

  return (
    <div className="footer">
      <Row>
        <Col>
          <a
            rel="noreferrer"
            target="_blank"
            href="https://www.vippreferred.com/privacy-policy"
            onClick={() => linkClick("Privacy Notice")}
          >
            Privacy Notice
          </a>{" "}
          |{" "}
          <a
            rel="noreferrer"
            target="_blank"
            href={GLBANOTICELINK}
            onClick={() => linkClick("GLBA Notice")}
          >
            GLBA Notice
          </a>
        </Col>
      </Row>
    </div>
  );
};

export default Footer;
